import React from 'react'
import { Tabs as MuiTabs, TabsProps } from '@mui/material'

interface PropsType extends TabsProps {}

export const Tabs = (props: PropsType) => {
	return <MuiTabs {...props}>{props.children}</MuiTabs>
}
